import { render, staticRenderFns } from "./ConfigurationActions.vue?vue&type=template&id=22c88fff&scoped=true"
import script from "./ConfigurationActions.vue?vue&type=script&lang=js"
export * from "./ConfigurationActions.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationActions.vue?vue&type=style&index=0&id=22c88fff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c88fff",
  null
  
)

export default component.exports